/**
 * @fileoverview gRPC-Web generated client stub for witbooking.loyalty.organization.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_type_money_pb = require('../../../../google/type/money_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.loyalty = {};
proto.witbooking.loyalty.organization = {};
proto.witbooking.loyalty.organization.v1 = require('./organization_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest,
 *   !proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse>}
 */
const methodDescriptor_OrganizationAPI_FindOrganizations = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.organization.v1.OrganizationAPI/FindOrganizations',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest,
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest,
 *   !proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse>}
 */
const methodInfo_OrganizationAPI_FindOrganizations = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient.prototype.findOrganizations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/FindOrganizations',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_FindOrganizations,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.FindOrganizationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.organization.v1.FindOrganizationsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient.prototype.findOrganizations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/FindOrganizations',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_FindOrganizations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.organization.v1.GetOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.GetOrganizationResponse>}
 */
const methodDescriptor_OrganizationAPI_GetOrganization = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.organization.v1.OrganizationAPI/GetOrganization',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.organization.v1.GetOrganizationRequest,
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.organization.v1.GetOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.GetOrganizationResponse>}
 */
const methodInfo_OrganizationAPI_GetOrganization = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.GetOrganizationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.organization.v1.GetOrganizationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient.prototype.getOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/GetOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_GetOrganization,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.GetOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.organization.v1.GetOrganizationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient.prototype.getOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/GetOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_GetOrganization);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse>}
 */
const methodDescriptor_OrganizationAPI_CreateOrganization = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.organization.v1.OrganizationAPI/CreateOrganization',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest,
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse>}
 */
const methodInfo_OrganizationAPI_CreateOrganization = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient.prototype.createOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/CreateOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_CreateOrganization,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.CreateOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.organization.v1.CreateOrganizationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient.prototype.createOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/CreateOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_CreateOrganization);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse>}
 */
const methodDescriptor_OrganizationAPI_UpdateOrganization = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.organization.v1.OrganizationAPI/UpdateOrganization',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest,
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse>}
 */
const methodInfo_OrganizationAPI_UpdateOrganization = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient.prototype.updateOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/UpdateOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_UpdateOrganization,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.UpdateOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.organization.v1.UpdateOrganizationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient.prototype.updateOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/UpdateOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_UpdateOrganization);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse>}
 */
const methodDescriptor_OrganizationAPI_DeleteOrganization = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.organization.v1.OrganizationAPI/DeleteOrganization',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest,
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest,
 *   !proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse>}
 */
const methodInfo_OrganizationAPI_DeleteOrganization = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse,
  /**
   * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIClient.prototype.deleteOrganization =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/DeleteOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_DeleteOrganization,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.organization.v1.DeleteOrganizationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.organization.v1.DeleteOrganizationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.organization.v1.OrganizationAPIPromiseClient.prototype.deleteOrganization =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.organization.v1.OrganizationAPI/DeleteOrganization',
      request,
      metadata || {},
      methodDescriptor_OrganizationAPI_DeleteOrganization);
};


module.exports = proto.witbooking.loyalty.organization.v1;

